module.exports = __webpack_public_path__ + "img/河南.f5a0b1d7.png";